<template>
  <v-dialog v-model="showDialog">
    <v-card id="geoInfo" width="400px">
      <v-img v-if="placeInfo.placePictureUrl" :src="placeInfo.placePictureUrl"
             class="white--text"
             height="200px">
        <v-container fill-height>
          <v-flex align-self-end>
            <span class="headline hcolor">{{ placeInfo.placeHeader }}</span>

          </v-flex>
        </v-container>
      </v-img>
      <v-card-title>
        <div>
          <span>{{ placeInfo.placeDescription }}</span>
        </div>
      </v-card-title>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  name: 'LocationPlaceInfo',
  data() {
    return {
      placeInfo: {
        placePictureUrl: null,
        placeHeader: null,
        placeDescription: null,
        placeId: null,
      },
      showDialog: false,
      markerObject: null,
      mapObject: null,
    };
  },
  methods: {
    showPlaceInfo(placeInfo, markerObject, mapObject) {
      this.placeInfo = placeInfo;
      this.markerObject = markerObject;
      this.mapObject = mapObject;
      if (placeInfo.placeId) {
        this.placeService = this.placeService ?
          this.placeService :
          new window.google.maps.places.PlacesService(mapObject);
        this.placeService.getDetails({
          fields: ['name', 'formatted_address', 'photos'],
          placeId: placeInfo.placeId,
        }, (result, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            this.placeInfo.placePictureUrl = result.photos && result.photos.length ?
              result.photos.find(item => item.getUrl()).getUrl() : null;
            this.placeInfo.placeDescription = (this.placeInfo.placePictureUrl ? '' : `${result.name}. `) +
              result.formatted_address;
            this.placeInfo.placeHeader = result.name;
          }
        });
      }
      this.openWindow();
    },
    openWindow() {
      const elm = document.getElementById('geoInfo');

      this.infoWindow = this.infoWindow ? this.infoWindow : new window.google.maps.InfoWindow({
        content: elm,
      });

      this.infoWindow.open(this.mapObject, this.markerObject);
    },
  },
};
</script>

<style lang="scss">
.hcolor {
  color: azure;
  text-shadow: 1px 1px 2px black;
}
</style>
